var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/tabber_mykit_unselected.c153c34b.png","uri@2x": __webpack_public_path__ + "static/media/tabber_mykit_unselected.a554ec8b.png","uri@3x": __webpack_public_path__ + "static/media/tabber_mykit_unselected.d5b7d4d4.png",
    width: 27,
    height: 27
});